import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { FiRefreshCw, FiChevronDown, FiChevronUp } from "react-icons/fi";
import { Button, Dropdown, Spinner } from "react-bootstrap";

const LoginActivity = () => {
    const [logs, setLogs] = useState([]);
    const [filteredLogs, setFilteredLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [staffList, setStaffList] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState("all");
    const [isOpen, setIsOpen] = useState(false);
    const [staffCounts, setStaffCounts] = useState({});
    const hasFetched = useRef(false);

    const fetchLogs = async () => {
        try {
            setLoading(true);
            const res = await axios.get("https://www.azzenterprises.com/api/customers/loghistory");

            const logsData = res.data.logs || [];
            setLogs(logsData);
            setFilteredLogs(logsData);
            setStaffList(res.data.staffList || []);

            // Count logins per staff
            const counts = {};
            logsData.forEach(log => {
                counts[log.staff_name] = (counts[log.staff_name] || 0) + 1;
            });
            setStaffCounts(counts);
        } catch (error) {
            console.error("Error fetching logs:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!hasFetched.current) {
            fetchLogs();
            hasFetched.current = true;
        }
    }, []);

    useEffect(() => {
        if (selectedStaff === "all") {
            setFilteredLogs(logs);
        } else {
            setFilteredLogs(logs.filter((log) => log.staff_name === selectedStaff));
        }
    }, [selectedStaff, logs]);

    const columns = [
        {
            name: "Customer Name",
            selector: (row) => row.full_name,
            sortable: true,
        },
        {
            name: "Staff Name",
            selector: (row) => row.staff_name,
            sortable: true,
        },
        {
            name: "Login Time",
            selector: (row) => row.login_time,
            sortable: true,
        },
    ];

    return (
        <div className="card shadow-sm">
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <Dropdown onToggle={(open) => setIsOpen(open)}>
                        <Dropdown.Toggle
                            variant="outline-secondary"
                            size="sm"
                            id="dropdown-staff"
                            className="d-flex align-items-center justify-content-between"
                            style={{ minWidth: "160px" }}
                        >
                            <span>{selectedStaff === "all" ? "All Staff" : selectedStaff}</span>
                            {isOpen ? <FiChevronUp className="ms-2" /> : <FiChevronDown className="ms-2" />}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item
                                key="all"
                                active={selectedStaff === "all"}
                                onClick={() => setSelectedStaff("all")}
                            >
                                All Staff ({logs.length})
                            </Dropdown.Item>
                            {staffList.map((staff) => (
                                <Dropdown.Item
                                    key={staff}
                                    active={selectedStaff === staff}
                                    onClick={() => setSelectedStaff(staff)}
                                >
                                    {staff} ({staffCounts[staff] || 0})
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>

                    <Button variant="outline-secondary" size="sm" onClick={fetchLogs}>
                        <FiRefreshCw /> Refresh
                    </Button>
                </div>

                {loading ? (
                    <div className="d-flex justify-content-center align-items-center py-5">
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : (
                    <DataTable
                        columns={columns}
                        data={filteredLogs}
                        pagination
                        highlightOnHover
                        responsive
                        striped
                        persistTableHead
                        fixedHeader
                        fixedHeaderScrollHeight="500px"
                        noDataComponent={<div className="text-center py-3">No records found</div>}
                    />
                )}
            </div>
        </div>
    );
};

export default LoginActivity;